import React, {Component} from "react";
import {Container, Label} from "reactstrap";
import { inject, observer } from "mobx-react";
import DataWrapper from "../../../principal/containers/DataWrapper";
import FiltrosImportacao from "../components/FiltrosImportacao";
import ImportacaoStore from "../stores/ImportacaoStore";
import { TabelaImportacao } from "../components/TabelaImportacao";
import ModalAviso from "../../../comum/components/ModalAviso";
import {ImportacaoDetalhes} from "../components/ImportacaoDetalhes";
import Footer from "../../../comum/components/Footer";
import FooterContent from "../../../comum/components/FooterContent";
import FooterOptions from "../../../comum/components/FooterOptions";
import IconButton from "../../../comum/components/IconButton";
import {makePDF} from "../../../../utils/formatar";
import ExportarExcelImportacao from "../components/ExportarExcelImportacao";
import ModalForm from "../../../comum/components/ModalForm";

@inject("store")
@DataWrapper
@observer
export class Importacao extends Component {
    constructor(props) {
        super(props);
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.appStore = this.props.store.appStore;
        this.controller = new ImportacaoStore();
    };

    mudaTitulo = () => {
        if (!this.controller.detalhesAtivo) {
           this.appStore.showVoltarTopBar(false, '/liberacoes-importacao', null);
            this.tituloPaginaStore.setTitulo("Liberação de Importação");
        } else {
           this.appStore.showVoltarTopBar(true, '/liberacoes-importacao', null, this.handleVoltar);
            const status = <React.Fragment>
                    <Label 
                        className={`situacao-btn
                            ${this.controller.linhaDetalhes.StatusProcesso 
                                ? this.controller.linhaDetalhes.StatusProcesso.toLowerCase().replace(/\s|\./g,'-') 
                                : ""}  situacao-titulo`}>
                                { this.controller.linhaDetalhes.StatusProcesso }
                            </Label>
                    { this.controller.linhaDetalhes.StatusProcesso ==="OK" && this.controller.validaContainerCheio() &&
                      <Label className={`liberacao-btn aviso-luminoso`}>Disponível para agendamento</Label>
                    }
                </React.Fragment>;
            this.tituloPaginaStore.setTituloEStatus(this.controller.linhaDetalhes.NumeroBl, status);
        }
    };

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Liberação de Importação");
        
        let voltarParam = _.get(this.props.location.state,`voltar`);
        this.props.store.appStore.showVoltarTopBar(voltarParam ? true : false, voltarParam ? voltarParam : '/');
    };


    handleVoltar = () =>{
        this.controller.detalhesAtivo = false;
        window.scrollTo(10, 10); // Bug da barra de rolagem com o cabeçalho do grid
        this.mudaTitulo();
    }

    aviso = () => {
        if (this.controller.listaMensagens)
            return <ModalAviso onClickFechar={ () => this.controller.listaMensagens = false }>
                { this.controller.listaMensagens.map((msg, x) =>
                    <h2 key={x}>{ msg }</h2>
                )}
        </ModalAviso>
    };

    novoDiModal = () => {
        if(this.controller.exibirModalNovaDi) {
            return <ModalForm
                className="tamanho-modal-500"
                labelConfirmar="Criar"
                habilitaSalvar={!this.controller.loadingNovoDi && this.controller.liberarCriacaoNovaDi}
                salvando={this.controller.loadingNovoDi}
                labelCancelar="Cancelar"
                onClickSalvar={this.controller.adicionarNovoDi}
                onClickCancelar={this.controller.fecharModalNovaDi}
            >
                <h2>Anexar arquivo</h2>
                <input type="file" onChange={e => this.controller.anexarArquivoNovaDi(e)} accept=".xml" />
                <Label>O arquivo anexado será do tipo XML DI CONSUMO</Label>
            </ModalForm>
        }
    }

    render() { 
        let pdfData = this.controller.todasColunas.slice();
        return (
            <div className="form-wrapper">
                <Container className="liberacao-importacao" fluid>
                    { this.aviso() }
                    { this.novoDiModal() }
                    <FiltrosImportacao controller={this.controller} />
                    <TabelaImportacao controller={this.controller} mudaTitulo={ () => this.mudaTitulo } />
                        {this.controller.detalhesAtivo && <ImportacaoDetalhes controller={this.controller} mudaTitulo={ () => this.mudaTitulo() } />}
                    
                </Container>

                { !this.controller.detalhesAtivo
                    && <Footer>
                        <FooterContent>
                            <div className="justify-content-between">
                                <div>
                                    <b>{this.controller.items.length}</b> Registros no Total
                                    { this.controller.estadoFiltros
                                        && <React.Fragment>
                                            - <a onClick={ () => this.controller.reListar() } >Atualizar Lista</a>
                                        </React.Fragment>
                                    }
                                    </div>
                                </div>
                        </FooterContent>
                        <FooterOptions>
                            <div>
                                <IconButton
                                    icon="file-pdf"
                                    text="Baixar PDF"
                                    size="md"
                                    disabled={this.controller.importacoes.length===0}
                                    onClick={
                                        () => makePDF(
                                            this.controller.importacoes,
                                            pdfData.map(elem => elem.dataField),
                                            pdfData.map(elem => elem.text),
                                            [],
                                            true,
                                            false,
                                            {qtdColFixo: "A2", nomeDoArquivo: "LiberaçãoDeImportação.pdf"}
                                        )
                                    }
                                />
                            </div>
                            <div>
                                <ExportarExcelImportacao controller={this.controller} />
                            </div>
                        </FooterOptions>
                    </Footer>
                }
            </div>
            
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/liberacoes/importacao/telas/Importacao.js